import { Outlet, useParams } from 'react-router-dom';

import { NotFound } from '@/components/ui/not-found';
import { useAuthContext } from '@/contexts/auth-context';
import { JobPostingProvider } from '@/contexts/job-posting-context';

export function RouteAuth() {
  const { accountSlug: accountSlugParam } = useParams();
  const { account } = useAuthContext();

  if (accountSlugParam && accountSlugParam !== account?.slug)
    return <NotFound />;

  return (
    <JobPostingProvider>
      <Outlet />
    </JobPostingProvider>
  );
}
